<template>
  <div class="appicon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 32" width="34px" height="32px" style="width: 34px;">
      <rect :style="getStyle('bg')" x="1.5" y="1.5" width="31" height="29" />
      <path :style="getStyle('fg')" d="M31,3V29H3V3H31m3-3H0V32H34V0Z" />
      <path
          class="appFG"
          :style="getStyle('fg')"
          :d="thisApp.charA"
        />
        <path
          class="appFG"
          :style="getStyle('fg')"
          :d="thisApp.charB"
        />
    </svg>
  </div>
</template>

<script>
export default {
  name: "appicon",
  props: {
    app: String,
    active: Boolean
  },
  computed: {
    thisApp() {
      return this.apps.find(item => {
        return item.name == this.app;
      })
    }
  },
  data: () => ({
    fgIdle: "var(--color-btn-disabled-text)",
    bgIdle: "var(--color-scrollbar-thumb)",
    apps: [
      {
        name: "AEFT",
        fg: "#ca8dfe",
        bg: "#1f003f",
        charA: "M10,8.32H12l4.88,14.44H15L12.45,14.7c-.52-1.62-1-3.2-1.45-4.87h-.09c-.44,1.68-.91,3.25-1.43,4.87L6.94,22.76H5.07ZM7.64,16.9h6.65v1.47H7.64Z",
        charB: "M19.09,17.43c0-3.48,2.34-5.62,4.81-5.62,2.72,0,4.26,1.95,4.26,5a5.9,5.9,0,0,1-.08,1h-7.2c.13,2.27,1.51,3.74,3.55,3.74a4.61,4.61,0,0,0,2.66-.86l.65,1.19A6.33,6.33,0,0,1,24.21,23C21.36,23,19.09,20.94,19.09,17.43Zm7.48-.87c0-2.15-1-3.31-2.64-3.31-1.51,0-2.85,1.2-3.07,3.31Z"
      },
      {
        name: "ILST",
        fg: "#f67400",
        bg: "#261300",
        charA: "M12.7,8.32h2.08l4.88,14.44H17.72L15.2,14.7c-.52-1.62-1-3.2-1.45-4.87h-.09c-.44,1.68-.91,3.25-1.43,4.87L9.69,22.76H7.82ZM10.39,16.9H17v1.47H10.39Z",
        charB: "M22.3,8.7a1.25,1.25,0,0,1,2.5,0,1.25,1.25,0,0,1-2.5,0Zm.33,3.37h1.81V22.76H22.63Z"
      },
      {
        name: "PHXS",
        fg: "#26c9ff",
        bg: "#061e26",
        charA: "M7.7,8.32h4.12c3.24,0,5.42,1.09,5.42,4.26S15.07,17,11.91,17H9.54v5.72H7.7Zm4,7.23c2.52,0,3.73-.92,3.73-3s-1.28-2.77-3.82-2.77H9.54v5.74Z",
        charB: "M19.68,21.54l.89-1.19a4.81,4.81,0,0,0,3.16,1.27c1.4,0,2.1-.75,2.1-1.66,0-1.1-1.26-1.59-2.45-2-1.5-.55-3.19-1.28-3.19-3.09s1.37-3,3.69-3A5.42,5.42,0,0,1,27.21,13l-.87,1.16a4,4,0,0,0-2.44-1c-1.35,0-2,.72-2,1.54,0,1,1.17,1.4,2.38,1.85,1.54.59,3.26,1.21,3.26,3.25,0,1.73-1.38,3.18-3.9,3.18A6.42,6.42,0,0,1,19.68,21.54Z"
      },
      {
        name: "IDSN",
        fg: "#fe388f",
        bg: "#26000f",
        charA: "M9.43,8.32h1.83V22.76H9.43Z",
        charB: "M15.38,17.43c0-3.47,2.19-5.62,4.63-5.62A4.4,4.4,0,0,1,23,13l-.08-1.83V7.09h1.81V22.76h-1.5l-.15-1.26H23A4.74,4.74,0,0,1,19.79,23C17.11,23,15.38,21,15.38,17.43Zm7.55,2.62V14.44a3.78,3.78,0,0,0-2.61-1.11c-1.71,0-3.07,1.65-3.07,4.09s1.06,4.09,2.94,4.09A3.72,3.72,0,0,0,22.93,20.05Z"
      },
      {
        name: "FLPR",
        fg: "#ff3413",
        bg: "#260600",
        charA: "M9.39,8.32h2.08l4.88,14.44h-2L11.89,14.7c-.52-1.62-1-3.2-1.45-4.87h-.09c-.44,1.68-.91,3.25-1.43,4.87L6.38,22.76H4.51ZM7.08,16.9h6.65v1.47H7.08Z",
        charB: "M19.32,12.07h1.5L21,13.61H21a5.11,5.11,0,0,1,3.59-1.8c2.25,0,3.26,1.45,3.26,4.18v6.77H26.07V16.22c0-2-.6-2.84-2-2.84-1.09,0-1.85.56-2.92,1.64v7.74H19.32Z"
      },
      {
        name: "PPRO",
        fg: "#e06bff",
        bg: "#2a0033",
        charA: "M8.38,8.32H12.5c3.24,0,5.42,1.09,5.42,4.26S15.75,17,12.59,17H10.22v5.72H8.38Zm4,7.23c2.53,0,3.73-.92,3.73-3s-1.28-2.77-3.82-2.77h-2v5.74Z",
        charB: "M21.76,12.07h1.5L23.41,14h.06a3.68,3.68,0,0,1,3-2.21,2.44,2.44,0,0,1,1.14.22l-.33,1.58a3.15,3.15,0,0,0-1-.17c-.9,0-2,.65-2.71,2.46v6.86H21.76Z"
      },
      {
        name: "AUDT",
        fg: "#00d9b1",
        bg: "#002620",
        charA: "M9.49,8.32h2.07l4.89,14.44H14.5L12,14.7c-.52-1.62-1-3.2-1.45-4.87h-.09C10,11.51,9.54,13.08,9,14.7L6.48,22.76H4.61ZM7.17,16.9h6.65v1.47H7.17Z",
        charB: "M19.15,18.85V12.07H21v6.54c0,2,.6,2.85,2,2.85,1.1,0,1.85-.54,2.87-1.8V12.07h1.81V22.76h-1.5L26,21.09h-.06A4.54,4.54,0,0,1,22.41,23C20.16,23,19.15,21.57,19.15,18.85Z"
      }
    ]
  }),
  methods: {
    getStyle(which) {
      if (!this.active) return `fill: ${this[`${which}Idle`]}`
      else return `fill: ${this.thisApp[which]}`
    }
  }
};
</script>

<style>
</style>
